/*!
 * jQuery TextSummary - v0.0.1 - 2017-12-07
 * github: necmi
 */
$.fn.textSummary = function (options, callback) {
    var settings = {
        maxlength: 250,
        morechar: ""
    };

    var options = $.extend(true, settings, options);

    return this.each(function () {
        var $context = $(this).hide().append($('<a>', {
            "class": "showless",
            href: "javascript:;",
            text: "("+$("#DahaKisa").val()+")",
            click: function (e) {
                e.preventDefault();
                $context.hide();
                $(".announcement-summary").show();

            }
        }));
        var contentChunks = $context.html().split(' ');
        console.log("***");
        console.log(contentChunks);
        console.log("***");
        var summarytext = new String();
        var exceeded = false;
        $.each(contentChunks, function (i, v) {
            if ((summarytext.length + v.length <= options.maxlength) && !exceeded) {
                if (i > 0) {
                    summarytext += ' ';
                }
                summarytext += v;
            } else {
                exceeded = true;
            }
        });

        var $summary = $('<p>', {
            "class": "announcement-summary"
        }).html(summarytext + options.morechar).insertBefore($context);

        if ($context.html().length > options.maxlength) {
            var sm = $("<a class='showmore' href='javascript:;'>..(" + $("#DahaFazla").val() + ")</a>");
                if ($summary.find("p,span").eq(0).length > 0) {

                    $summary.find("p,span").eq(0).append(sm);

                } else {

                    $summary.append(sm);

                }
                sm.on("click", function (e) {
                    e.preventDefault();
                    $context.show();
                    $(".announcement-summary").hide();
                });
        }
        if ($.isFunction(callback)) { callback(); }
    });
};